// extracted by mini-css-extract-plugin
export default {"znakWodny":"OchronaEkranu_znakWodny__TYDUG","pas":"OchronaEkranu_pas__lmAH-","napis":"OchronaEkranu_napis__YXW65","komunikatDruku":"OchronaEkranu_komunikatDruku__iGebf"};